

exports.__esModule = true;
exports.$UpdateCardPageRoute = undefined;

require('./directive');

var _squid = require('squid');

var $UpdateCardPageRoute = exports.$UpdateCardPageRoute = _squid.$ComponentRoute.extend('$UpdateCardPageRoute', {

    path: 'updateCard',
    directive: 'xo-update-card-page',
    titleContent: 'asideHeader.update',
    query: ['message'],
    trackingData: {
        templateName: 'tray/editCard.dust',
        pageGoal: 'Update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-edit-cc',
                'pagename2': '%::fullpage-edit-cc:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            isUpdateFlow: 'isUpdateFlow',
            cardmodel: 'cardmodel',
            'parent-callbacks': 'callbacks'

        }
    }]
});

angular.value("$UpdateCardPageRoute", $UpdateCardPageRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-update-card/route.js
// module id = ./pages/xo-update-card/route.js
// module chunks = 1